const buildRugSlug = (rugName: string) => {
  const trimmed = rugName.trim();
  const replacedSpaces = trimmed.replace(/ /g, '-');

  return encodeURIComponent(replacedSpaces);
};

export default buildRugSlug;
